// eslint-disable-next-line import/named
import {ConfigProviderProps} from 'antd/es/config-provider';

type ValidateMessages = Required<Required<ConfigProviderProps>['form']>['validateMessages'];

const validateMessages: ValidateMessages = {
    required: 'Required',
    whitespace: 'No spaces allowed',

    string: {
        min: '${label} at least ${min} characters', // NOSONAR
        max: '${label} no more than ${max} characters', // NOSONAR
        range: '${label} from ${min} to ${max} characters', // NOSONAR
        len: '${label} consists of ${len} characters', // NOSONAR
    },

    number: {
        min: 'Value of ${label} is not less than ${min}', // NOSONAR
        max: 'Value of ${label} is not more than ${max}', // NOSONAR
        range: 'Value of ${label} from ${min} to ${max}', // NOSONAR
    },

    types: {
        string: 'Field ${label} must be a string', // NOSONAR
        number: 'Field ${label} must be a number', // NOSONAR
        email: 'Field ${label} must be in email format', // NOSONAR
        url: 'Field ${label} must be in URL format', // NOSONAR
        array: 'Field ${label} must be an enum', // NOSONAR
    },
};

export default validateMessages;
